import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Datos from '../package.json';

const Footer = () => {
    const[version,setVersion] = useState(Datos.version);
  return (
    <Paper
      square
      elevation={4}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        padding: '10px',
        textAlign: 'left',
      }}
    >
      <Typography variant="body2" color="blue" sx={{ml:5}}>
        Version: {version}
      </Typography>   
    </Paper>
  );
};

export default Footer;
